import {DropinModalInitial} from '../dropinModal/dropin-modal-initial/DropinModalInitial';
import {useArrivalContext} from '../../../context/ArrivalContext';
import {DropinModalPeople} from '../dropinModal/dropin-modal-people/DropinModalPeople';
import {useEffect} from 'react';
import {DropinDeviceCompleted} from './DropinDeviceCompleted';
import {DropinEidPeople} from './DropinEidPeople';
import {useSessionContext} from 'src/context/SessionContext';
import {DropinModalHD} from '../dropinModal/dropin-modal-hd/DropinModalHD';

interface ArrivalDropInOnDeviceProps {
    setShowNav: (show: boolean) => void;
}

export function ArrivalDropInOnDevice({setShowNav}: ArrivalDropInOnDeviceProps) {
    const {dataState} = useArrivalContext();
    const {step} = dataState;
    const {clearSession} = useSessionContext();

    useEffect(() => {
        clearSession({redirectToHome: false});
    }, []);

    useEffect(() => {
        setShowNav(step === 'initial');
    }, [step, setShowNav]);

    const stepComponent = () => {
        switch (step) {
            case 'initial':
                return <DropinModalInitial />;
            case 'people':
                if (dataState.settings?.dropinEid) {
                    return <DropinEidPeople />;
                } else {
                    return <DropinModalPeople />;
                }
            case 'hd':
                return <DropinModalHD />;
            case 'completed':
                return <DropinDeviceCompleted />;
        }
    };

    return <div className='arrival-dropin-component'>{stepComponent()}</div>;
}
